import { render, staticRenderFns } from "./TheNavigation.vue?vue&type=template&id=2be5c5ba&"
import script from "./TheNavigation.vue?vue&type=script&lang=js&"
export * from "./TheNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports